const $http = require('axios');
const ChangeCart = '/cart/change.js';
const AddToCart = '/cart/add.js';
const GetCart = '/cart.js';

export class CartService {
  constructor() { }

  /** CHANGE ITEM IN CART
   * @param { item quantity } qty
   * @param { item id } id
   */
  changeItem(qty, variant_id) {
    return $http.post(ChangeCart, {
      id: variant_id,
      quantity: qty,
    }).then((resp) => resp.data).catch((error) => console.error(error));
  }

  /** CHANGE ITEM IN CART
   * @param { item quantity } qty
   * @param { item varient ID } variant_id
   */
  addItem(qty, variant_id, properties) {
    return $http.post(AddToCart, {
      id: variant_id,
      quantity: qty,
      properties: properties,
    }).then(() => {
      /** this resp is the product data - must update store cart data with additional call */
      return this.getCartData().then((resp) => {
        // send cart data back to store.
        return resp;
      });
    }).catch((error) => console.error(error));
  }

  // GET CART DATA
  getCartData() {
    const TimeStamp = new Date().getTime();
    const Url = `${GetCart}?q=${TimeStamp}`;

    return $http.get(Url).then((resp) => resp.data).catch((error) => console.error(error));
  }
}
